import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import SimpleEncrypt from 'simple-encryptor'
// import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'order',
  components: {
    //Paginate,
    Pagination,
    DatePicker,
    JsonExcel,
    Loader,
  },
  data() {
    return {
      answer: '',
      isLoadingforxls: false,
      show: false,
      download: true,
      dataFilter2: '',
      reportname: '',
      csvFieldsForXls: {},
      listReportDataforxls: [],
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,

      listOrdersData: [],
      listOrdersDataCsv: [],
      modalShow: false,
      modalMessageShow: false,
      displayMsg: false,
      successErrorMsg: "",
      pono: "",
      ponoFlt: "",
      shipidflt: "",
      fromDateFlt: "",
      toDateFlt: "",
      fromDateFltShip: "",
      toDateFltShip: "",
      newActionMsg: "",
      modelMessage: "",
      // totalPage: 0,
      // pageNo: 0,
      activeClass: 'btn-success',
      warningClass: 'btn-warning',
      showinvoicemodal: false,
      shippingdata: [],
      shippinginvoicedata: [],
      shippinginvoicedatacal: [],
      clientdata: [],
      shippingcharges: 0,
      invoiceheadername: '',
      invoicephname: '',
      resultCount: 0,
      listClientData: [],
      listWarehouseData: [],
      clientid: '',
      client: '',
      warehouseid: '',
      warehouse: '',
      ClientErr: '',
      WarehouseErr: '',
      ClientErr: '',
      searchFlag: false,
      showSelectWarehouse: false,
      showSelectClient: false,
      cancelOrderId: '',
      loginuserid: '',
      cancelreasonid: '',
      orderstatuslist: [{
        'status': 'created'
      }, {
        'status': 'allocated'
      }, {
        'status': 'picked'
      }, {
        'status': 'packed'
      }, {
        'status': 'dispatched'
      }, {
        'status': 'cancelled'
      }, {
        'status': 'rto'
      }],
      searchstatus: '',
      channellist: [],
      isLoading: false,
      displayCancel: false,
      // perPage: 10,
      formattedDate: '',
      shipmentdetails: false,
      shipmentdetailslist: '',
      orderidshipment: '',
      fromDateFltStatus: '',
      toDateFltStatus: '',
      statusFlag: false,
      labelfromdate: '',
      labeltodate: '',
      userid: '',
      cancelOrderFlag: false,
      downloadButtonFlag: false,
      OthersReason: '',
      cancelReason: '',
      limitExeed: false,
      recordLimit: 0,
    }
  },
  model: {
    totalqty: 0,
    grdtotalmrp: 0,
    totalamountpayable: 0,
    totaltaxablevalue: 0,
    totalcgstamt: 0,
    totalsgstamt: 0,
    totaligstamt: 0,
  },
  computed: {
    totalamountpayable: function() {
      return this.shippinginvoicedatacal.reduce(function(totalamountpayable, item) {
        return totalamountpayable + parseFloat(item.amountpayable)
      }, 0);
    },
    grdtotalmrp: function() {
      return this.shippinginvoicedatacal.reduce(function(grdtotalmrp, item) {
        return grdtotalmrp + (parseFloat(item.mrp) * parseFloat(item.pickqty));
      }, 0);
    },
    totalqty: function() {
      return this.shippinginvoicedatacal.reduce(function(totalqty, item) {
        return totalqty + parseFloat(item.pickqty);
      }, 0);
    },
    totaltaxablevalue: function() {
      return this.shippinginvoicedatacal.reduce(function(totaltaxablevalue, item) {
        return totaltaxablevalue + parseFloat(item.taxablevalue);
      }, 0);
    },
    totalcgstamt: function() {
      return this.shippinginvoicedatacal.reduce(function(totalcgstamt, item) {
        return totalcgstamt + parseFloat(item.cgstamount);
      }, 0);
    },
    totalsgstamt: function() {
      return this.shippinginvoicedatacal.reduce(function(totalsgstamt, item) {
        return totalsgstamt + parseFloat(item.sgstamount);
      }, 0);
    },
    totaligstamt: function() {
      return this.shippinginvoicedatacal.reduce(function(totaligstamt, item) {
        return totaligstamt + parseFloat(item.igstamount);
      }, 0);
    },
  },
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    this.calldateFunction();
    this.listClientData = '';
    this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
    this.encryptor = SimpleEncrypt(this.key);
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
    var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
    var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
    var innerdetail = JSON.parse(innerplaintext);
    this.getComponentPermission(innerdetail);
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client

    this.reportname = this.$t('common.order'),
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    this.userid = userdetail.userid;
    var roleids = userdetail.roleid.split(',');
    for (var i = 0; i < roleids.length; i++) {
      if (roleids[i] == 40) {
        this.purchasingManager = parseInt(userdetail.roleid);
        this.isTrue = true;
      }
    }
    this.loginuserid = userdetail.userid;
    var loginuseremail = userdetail.email;
    this.pageNo = 0;

    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')

    // User access conditions
    if (userdetail.roleid == 1 || userdetail.roleid == 4) {
      this.displayCancel = true
    }

    this.user_type = userdetail.utype;
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        // this.getCancelReasonList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        this.client = this.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        // this.getCancelReasonList();

        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.warehouse = this.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        // this.getCancelReasonList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error(this.$t('common.unauthorisedError'));
        break
    }
    this.getRecordLimit()
    // var encrypted = this.encryptor.encrypt(this.userid);
    // var decrypted = this.encryptor.decrypt(encrypted);
    // alert(encrypted);
    // alert(decrypted);

  }, // End computed
  methods: {
    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = [], dataFilter = {}) {
      //  var data = this.listStockReportData;
      var csvData = ''
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }

      csvData += ''
      Object.entries(dataFilter).forEach(([k, v]) => {
        csvData += k + ':' + v + ','
      })
      csvData += '\r\n'
      csvData += '\r\n'
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ','
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
      //Data
      data.map(function(item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + '' // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilder.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
              else
                csvData += escapedCSV + ','
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1)
        csvData += '\r\n'
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n')
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData
    },

    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    getRecordLimit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRecordLimit',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data) {
            this.recordLimit = result.data.data;


          }
        }, error => {
          console.error(error)
        })
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    Choosetype() {
      this.show = true;
      this.download = false;
      if (!this.limitExeed) {
        this.getOrderListForXls(1)
      }
    },
    checkshipemtstatus() {
      this.$alertify.error(this.$t('common.orderCancelError'));

    },
    encryptData(encData) {
      return this.encryptor.encrypt(encData);
    },
    decryptData(decData) {
      return this.encryptor.decrypt(decData);
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    dateFormatFRT(date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    },
    dateFormat1(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 00:00:00";
    },
    dateFormat2(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD') + " 23:59:59";
    },
    calldateFunction: function() {
      this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      this.toDateFlt = this.currentDate;
      var dt = new Date(this.currentDate);
      dt.setDate(dt.getDate() - 7);
      this.fromDateFlt = dt;
    },

    time() {
      var self = this
      this.datenow = moment().format()
      setInterval(self.time, 1000)
    },
    getComponentPermission(innerdetail) {
      var component = 'orders';
      var innerpermArr = {};
      for (var i = 0; i < innerdetail.length; i++) {
        if (innerdetail[i].controllerurl == component) {
          innerpermArr = innerdetail[i].permission;
          break;
        }
      }
      if (JSON.stringify(innerpermArr) == 'null') {
        //alert("wrong");
      } else {
        for (var i = 0; i < innerpermArr.length; i++) {
          if (innerpermArr[i].id == 'cancel') {
            this.cancelOrderFlag = true;
          }
          if (innerpermArr[i].id == 'download') {
            this.downloadButtonFlag = true;
          }
        }
      }

    },

    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    hideShowdateFlt() {
      if (this.searchstatus == "created" || this.searchstatus == "") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = false;
        this.labelfromdate = '';
        this.labeltodate = '';
      }
      if (this.searchstatus == "allocated") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.allocatedFromDate');
        this.labeltodate = this.$t('editedjson.allocatedToDate');
      }
      if (this.searchstatus == "picked") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('cancelPutawayPendingReport.pickedFromDate');
        this.labeltodate = this.$t('cancelPutawayPendingReport.pickedToDate');
      }
      if (this.searchstatus == "packed") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.packedFromDate');
        this.labeltodate = this.$t('editedjson.packedToDate');
      }
      if (this.searchstatus == "dispatched") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('editedjson.dispatchedFromDate');
        this.labeltodate = this.$t('editedjson.dispatchedToDate');
      }
      if (this.searchstatus == "cancelled") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('cancelPutawayPendingReport.cancelledFromDate');
        this.labeltodate = this.$t('cancelPutawayPendingReport.cancelledToDate');
      }
      if (this.searchstatus == "rto") {
        this.fromDateFltStatus = '';
        this.toDateFltStatus = '';
        this.statusFlag = true;
        this.labelfromdate = this.$t('srReport.rTOFromDate');
        this.labeltodate = this.$t('srReport.rTOToDate');
      }
    },
    // getClientList() {
    //   this.pageno = 0;
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {
    //     this.listClientData = '';
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     if (this.warehouseid)
    //       this.input = ({
    //         warehouseid: this.warehouseid,
    //       });
    //     else {
    //       this.input = {};
    //     }

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr,
    //         }
    //       })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    // getWarehouseList() {
    //   this.pageno = 0;
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.input = ({
    //       clientid: this.clientid,
    //     });
    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr
    //         }
    //       })
    //       .then(result => {
    //         // console.log(result.data.data);
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },
    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     if (this.clientid)
    //       this.getSalesChannels();
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.getWarehouseList();
    //       if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //         this.warehouse = this.warehouseid = '';
    //       } else {
    //         this.warehouse = ''
    //       }
    //     } else {
    //       if (this.warehouseid && this.clientid) {
    //         //this.getOrderList();
    //       }
    //     }
    //   }
    //   this.listOrdersData = [];
    //   this.pageno = this.totalPage = 0;
    // },

    // warehouseSelected() {
    //   this.warehouseid = this.warehouse;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //       this.getSalesChannels();
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },

    getSalesChannels() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');

      if (this.clientid == '') {
        this.WarehouseErr = this.$t('common.clientError');;
        return false;
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'orderSalesChannelList',
          'data': {
            clientid: this.clientid
          },
          headers: {
            'Authorization': 'Bearer ' + myStr,
          }
        })
        .then(result => {
          this.channellist = result.data.data;
        }, error => {
          console.error(error);
        });
    },

    getOrderList(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var dataFilter = {};
      if (csvCheck == 2) {
        this.show = false;
        this.download = true;
        this.limitExeed = false;
      }
      if (this.ponoFlt == '' && (this.fromDateFlt == '' || this.fromDateFlt == null) && (this.toDateFlt == '' || this.toDateFlt == null)) {
        this.$alertify.error(this.$t('common.selectTimeFrameError'));
        this.pageNo = this.totalPage = 0;
        this.listOrdersData = [];
        this.totalRows = 0;
        return false;
      }
      var months;
      var fromDate = new Date(this.fromDateFlt);
      var ToDate = new Date(this.toDateFlt);
      months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

      if (this.ponoFlt == '' && months > 3) {
        this.$alertify.error(this.$t('common.selectTimeFrameError'));
        this.pageNo = this.totalPage = 0;
        this.totalRows = 0;
        this.listOrdersData = [];
        return false;
      }

      if (this.fromdate != "") {
        this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
      }
      if (this.todate != "") {
        this.todate = this.dateFormat(this.todate) + " 23:59:59";
      }

      // this.ClientErr = '';
      if (window.localStorage.getItem('selectedClient')==='undefined') {
        this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.totalPage = 0;
        this.listOrdersData = [];
        return false;
      }

      if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
        this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.totalPage = 0;
        this.listOrdersData = [];
        return false;
      }

      this.isLoading = true;

      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        orderid: this.ponoFlt.trim(),
        shipmentid: this.shipidflt.trim(),
        orderfromdate: this.dateFormat1(this.fromDateFlt),
        ordertodate: this.dateFormat2(this.toDateFlt),
        shipfromdate: this.dateFormat1(this.fromDateFltShip),
        shiptodate: this.dateFormat2(this.toDateFltShip),
        warehouseid:  window.localStorage.getItem('selectedWarehouse'),
        clientid: window.localStorage.getItem('selectedClient'),
        status: this.searchstatus,
        iscsv: csvCheck,
      });
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getmultisellerlist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 1) {
            this.show = true;
            this.download = false;
            this.csvFields = {
              'createddatetime': this.$t('common.createdDateTime'),
              'customername': this.$t('orders.customerName'),
              'isinvoiced': this.$t('multiSellerPanel.isInvoiced'),
              'ismarkedrtd': this.$t('multiSellerPanel.isMarkedRtd'),
              'orderdate': this.$t('common.orderDate'),
              'orderid': this.$t('common.orderID'),
              'processstatus': this.$t('common.processStatus'),
              'pushedstatus': this.$t('multiSellerPanel.pushedStatus'),
              'saleschannel': this.$t('common.salesChannel'),
              'shipbydate': this.$t('common.shipByDate'),
              'shipmentcnt': this.$t('common.shipmentId'),
              'shipmentid': this.$t('common.shipmentId'),
              'totalqty': this.$t('common.totalQTY'),
              'totalsku': this.$t('common.totalSKU'),
              'warehouseid': this.$t('common.warehouseID'),
            };
            var dateFilter = ['createddatetime', 'orderdate', 'modifieddatetime', 'shipbydate', 'lastmodifieddate', 'dispatcheddatetime'];
            var skipFilter = ['orderdate', 'shipmentstatusct', 'shipmentstatus', 'warehouseid'];
            this.listOrdersDataCsv = result.data.data[0].data.data;
            this.jsonToCSV(this.$t('common.order'), this.listOrdersDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

          } else {
            if (result.data.data[0].ErrorCode == -1) {
              this.listOrdersData = [];
              this.resultCount = 0;
              this.totalRows = 0;
              this.$alertify.error(result.data.data[0].msg);
            } else {
              this.listOrdersData = result.data.data[0].data.data;
              if (this.listOrdersData.length == 0) {
                this.$alertify.error(result.data.data[0].msg);

              } else {
                this.$alertify.success(result.data.data[0].msg);

              }


              this.totalRows = result.data.data[0].data.totalRows;
              this.resultCount = result.data.data[0].data.totalRows;
              if (this.totalRows <= this.pageLimit) {
                this.totalPage = 1;
              } else {
                this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
              }
            }
          }

          this.isLoading = false;
        }, error => {
          console.error(error);
        })
    },
    getOrderListForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var dataFilter = {};

      if (this.fromdate != "") {
        this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
      }
      if (this.todate != "") {
        this.todate = this.dateFormat(this.todate) + " 23:59:59";
      }
      // this.ClientErr = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';

      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        orderid: this.ponoFlt.trim(),
        shipmentid: this.shipidflt.trim(),
        orderfromdate: this.dateFormat1(this.fromDateFlt),
        ordertodate: this.dateFormat2(this.toDateFlt),
        shipfromdate: this.dateFormat1(this.fromDateFltShip),
        shiptodate: this.dateFormat2(this.toDateFltShip),
        warehouseid:  window.localStorage.getItem('selectedWarehouse'),
        clientid:  window.localStorage.getItem('selectedClient'),
        status: this.searchstatus,
        iscsv: csvCheck,
      });
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getmultisellerlist',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (csvCheck == 1) {
            if (result.data.data.length > 0) {
              this.listReportDataforxls = [];
              this.csvFieldsForXls[this.$t('common.customerName')]='customername'
              this.csvFieldsForXls[this.$t('common.orderID')]='orderid'
              this.csvFieldsForXls[this.$t('common.shipmentId')]='shipmentid'
              this.csvFieldsForXls[this.$t('common.orderDate')]='orderdate'
              this.csvFieldsForXls[this.$t('common.totalSKU')]='totalsku'
              this.csvFieldsForXls[this.$t('common.totalQTY')]='totalqty'
              this.csvFieldsForXls[this.$t('common.shipmentId')]='shipmentcnt'
              this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel'
              this.csvFieldsForXls[this.$t('common.processStatus')]='processstatus'
              this.csvFieldsForXls[this.$t('multiSellerPanel.pushedStatus')]='pushedstatus'
              this.csvFieldsForXls[this.$t('common.shipByDate')]='shipbydate'
              this.csvFieldsForXls[this.$t('common.createdDateTime')]='createddatetime'
              this.csvFieldsForXls[this.$t('multiSellerPanel.isInvoiced')]='isinvoiced'
              this.csvFieldsForXls[this.$t('multiSellerPanel.isMarkedRtd')]='ismarkedrtd'
              this.csvFieldsForXls[this.$t('common.warehouseID')]='warehouseid'
              this.listReportDataforxls = result.data.data[0].data.data;
              this.listReportDataforxls.forEach(function(entry) {
                if (entry.shipbydate != '' && entry.shipbydate != null) {
                  entry.shipbydate = moment(entry.shipbydate).format('YYYY-MM-DD HH:mm:ss');

                }
                if (entry.lastmodifieddate != '' && entry.lastmodifieddate != null) {
                  entry.lastmodifieddate = moment(entry.lastmodifieddate).format('YYYY-MM-DD HH:mm:ss');

                }
                if (entry.dispatcheddatetime != '' && entry.dispatcheddatetime != null) {
                  entry.dispatcheddatetime = moment(entry.dispatcheddatetime).format('YYYY-MM-DD HH:mm:ss');

                }
                if (entry.createddatetime != '' && entry.createddatetime != null) {
                  entry.createddatetime = moment(entry.createddatetime).format('YYYY-MM-DD HH:mm:ss');

                }
                if (entry.orderdate != '' && entry.orderdate != null) {
                  entry.orderdate = moment(entry.orderdate).format('YYYY-MM-DD HH:mm:ss');

                }
                if (entry.modifieddatetime != '' && entry.modifieddatetime != null) {
                  entry.modifieddatetime = moment(entry.modifieddatetime).format('YYYY-MM-DD HH:mm:ss');

                }
              });

            } else {
              if (result.data.status == true) {
                this.$alertify.success(this.$t('common.reportSizeError'));
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }


          }



        }, error => {
          console.error(error);
        })
    },


    showorderinvoice(shippingid, type) {
      let userToken = window.localStorage.getItem('userToken')
      let myStr = userToken.replace(/"/g, '');
      this.showinvoicemodal = true;
      this.input = ({
        shippingid: shippingid,
        warehouseid:  window.localStorage.getItem('selectedWarehouse'),
        clientid: this.clientid,
      });
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getOrderInvoiceData',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          var result = result.data.data[0];
          if (result.status != true) {
            console.error(result.msg);
          } else {
            this.shippingdata = result.data.invoicedata[0];
            this.shippinginvoicedata = result.data.invoicedata;
            this.clientdata = result.data.clientdata;
            this.shippingcharges = this.shippingdata.shippingcharges == null || this.shippingdata.shippingcharges == '' ? 0 : this.shippingdata.shippingcharges;
            if (type == 'taxinvoice') {
              this.invoiceheadername = "TAX INVOICE";
              this.invoicephname = "Name Of Pharmacist: ";
            } else if (type == 'custinvoice') {
              this.invoiceheadername = "Customer Acknowledgement";
              this.invoicephname = "Customer Signature & Phone No.";
            }
            this.shippinginvoicedatacal = [];
            for (var i = 0; i < this.shippinginvoicedata.length; i++) {
              var gst = 0;
              var totalmrp = 0;
              var amountpayable = 0;
              var taxablevalue = 0;
              var igstamount = 0;
              var cgstamount = 0;
              var sgstamount = 0;

              var sgstper = 0;
              var cgstper = 0;
              var igstper = 0;

              totalmrp = ((this.shippinginvoicedata[i].mrp * this.shippinginvoicedata[i].pickqty));
              amountpayable = totalmrp - (Number(this.shippinginvoicedata[i].invoiceleveldiscount));
              if (Number(this.shippinginvoicedata[i].hsnrate) > 0) {
                if (this.shippingdata.custstate == this.clientdata.state) {
                  sgstper = Number(this.shippinginvoicedata[i].hsnrate) / 2;
                  cgstper = Number(this.shippinginvoicedata[i].hsnrate) / 2;
                  igstper = 0;
                  gst = Number(sgstper) + Number(cgstper);
                  taxablevalue = ((amountpayable) / (1 + (gst / 100)));
                  igstamount = 0;
                  cgstamount = ((taxablevalue) * (Number(sgstper) / 100));
                  sgstamount = ((taxablevalue) * (Number(cgstper) / 100));
                } else {
                  sgstper = 0;
                  cgstper = 0;
                  igstper = Number(this.shippinginvoicedata[i].hsnrate);
                  gst = Number(igstper);
                  taxablevalue = ((amountpayable) / (1 + (gst / 100)));
                  igstamount = ((taxablevalue) * (Number(igstper) / 100));
                  cgstamount = 0;
                  sgstamount = 0;
                }
              } else {
                taxablevalue = amountpayable
                sgstper = 0;
                cgstper = 0;
                igstper = 0;
                igstamount = 0;
                cgstamount = 0;
                sgstamount = 0;
              }
              this.shippinginvoicedatacal.push({
                "productname": this.shippinginvoicedata[i].productname,
                "brand": this.shippinginvoicedata[i].brand,
                "strength": this.shippinginvoicedata[i].strength,
                "lotcontrol": this.shippinginvoicedata[i].lotcontrol,
                "expirydate": this.shippinginvoicedata[i].expirydate,
                "hsncode": this.shippinginvoicedata[i].hsncode,
                "pickqty": this.shippinginvoicedata[i].pickqty,
                "primaryuom": this.shippinginvoicedata[i].primaryuom,
                "mrp": this.shippinginvoicedata[i].mrp,
                "totalmrp": totalmrp,
                "discount": this.shippinginvoicedata[i].invoiceleveldiscount,
                "amountpayable": amountpayable,
                "taxablevalue": taxablevalue,
                "sgstper": sgstper,
                "cgstper": cgstper,
                "igstper": igstper,
                "igstamount": igstamount,
                "cgstamount": cgstamount,
                "sgstamount": sgstamount,

              })
            }
          }
        }, error => {
          console.error(error)
        })

    },
    // called onchange of client id
    getNewClientData() {
      this.pageNo = 0;
      this.totalPage = 0;
      this.resultCount = 0;
      this.searchFlag = false;
      this.listOrdersData = [];
      this.ponoFlt = '';
      this.shipidflt = '';
      this.fromDateFlt = "";
      this.toDateFlt = "";
      this.fromDateFltShip = "";
      this.toDateFltShip = "";
      document.getElementById('ponoFlt').value = "";
      document.getElementById('shipidflt').value = "";


      if (this.client == "") {
        return false;
      } else {
        this.getOrderList();
      }
    },
    // getPaginationData(currentPage) {
    // 	this.pageNo = (currentPage - 1) * this.perPage;
    // 	this.getOrderList()
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getOrderList()
    },
    getOrderSerach() {
      this.totalPage = 0;
      this.currentPage = 1;
      this.resultCount = 0;
      this.searchFlag = true;
      this.getOrderList(2);
    },
    resetOrderSerach() {
      this.isLoadingforxls = false;
      this.show = false;
      this.download = true;
      this.ClientErr = '';
      this.$validator.reset();
      this.ponoFlt = '';
      this.shipidflt = '';
      this.fromDateFlt = "";
      this.toDateFlt = "";
      this.fromDateFltShip = "";
      this.toDateFltShip = "";
      this.searchstatus = '';
      document.getElementById("searchstatus").value = '';
      this.listOrdersData = [];
      this.pageNo = 0;
      this.totalPage = 0;
      this.resultCount = 0;
      this.totalRows = 0;
      this.searchFlag = false;
      this.statusFlag = false;
      this.fromDateFltStatus = '';
      this.toDateFltStatus = '';
      if (this.user_type == 'warehouse_user')
        this.client = '';
      else if (this.user_type == 'client_user')
        this.warehouse = '';
      else {
        this.client = '';
        this.warehouse = '';
      }
      // this.getOrderList();
    },
    formatPrice(value) {
      value = value ? value : 0;
      return Number.parseFloat(value).toFixed(2);
    },


    //shipmentDetails
    shipmentDetails(poid, shipmentcount) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var shipmentcount = shipmentcount;
      if (shipmentcount) {
        this.shipmentdetailslist = '';
        this.orderidshipment = poid;
        this.input = {
          warehouseid:  window.localStorage.getItem('selectedWarehouse'),
          clientid: this.clientid,
          orderno: this.orderidshipment
        };
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'shipmentsDetailsOfOrder',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then(result => {
            if (result.data.errorCode == 0) {
              this.shipmentdetailslist = result.data.data;
              this.shipmentdetails = true;
            } else {
              this.shipmentdetailslist = {};
              this.shipmentdetails = true;
            }
          }, error => {
            console.error(error)
          })
      }
    },
    //shipmentdetails Close
    shipmentDetailsClose() {
      this.shipmentdetails = false;
      this.orderidshipment = '';
      this.shipmentdetailslist = '';
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid', this.model)
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    viewOrderData(data) {
      this.pono = data.poid;
      window.localStorage.setItem('pono', this.pono);
      window.localStorage.setItem('client', this.client);
      window.location.href = apiUrl.baseUrl + 'orderdetails';
    },
    number2text(value) {
      var res = '';
      var fraction = Math.round(this.frac(value) * 100);
      var f_text = "";

      if (fraction > 0) {
        f_text = "And " + this.convert_number(fraction) + " Paise";
      }
      return this.convert_number(value) + " Rupees " + f_text + " Only";
    },
    frac(f) {
      return f % 1;
    },

    convert_number(number) {
      if ((number < 0) || (number > 999999999)) {
        return "NUMBER OUT OF RANGE!";
      }
      var Gn = Math.floor(number / 10000000); /* Crore */
      number -= Gn * 10000000;
      var kn = Math.floor(number / 100000); /* lakhs */
      number -= kn * 100000;
      var Hn = Math.floor(number / 1000); /* thousand */
      number -= Hn * 1000;
      var Dn = Math.floor(number / 100); /* Tens (deca) */
      number = number % 100; /* Ones */
      var tn = Math.floor(number / 10);
      var one = Math.floor(number % 10);
      var res = "";

      if (Gn > 0) {
        res += (this.convert_number(Gn) + " Crore");
      }
      if (kn > 0) {
        res += (((res == "") ? "" : " ") +
          this.convert_number(kn) + " Lakh");
      }
      if (Hn > 0) {
        res += (((res == "") ? "" : " ") +
          this.convert_number(Hn) + " Thousand");
      }
      if (Dn) {
        res += (((res == "") ? "" : " ") +
          this.convert_number(Dn) + " Hundred");
      }

      var ones = Array("", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen");
      var tens = Array("", "", "Twenty", "Thirty", "Fourty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety");

      if (tn > 0 || one > 0) {
        if (!(res == "")) {
          res += " And ";
        }
        if (tn < 2) {
          res += ones[tn * 10 + one];
        } else {

          res += tens[tn];
          if (one > 0) {
            res += (" " + ones[one]);
          }
        }
      }
      if (res == "") {
        res = "zero";
      }
      return res;
    },
    print() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
body{
-webkit-print-color-adjust:exact;
}
table {
  font-size: 14px !important;
  margin-top: 10px !important;
}
,
@media print {
  table {
    border: solid #000 !important;
    border-width: 1px 0 0 1px !important;
    width:100% !important;
    margin-right:10px !important;
  }
  th,
  td {
    border: solid #000 !important;
  }
  .maintb{
    font-size: 14px !important;
  }
}
`
      d.print(document.getElementById('orderinvoiceContent'), cssText);

    },



  } // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/multiseller/multisellerorder/multisellerorder.component.js